<template>
  <v-flex>
    <v-data-table
      v-model="relatedTaxonomy"
      :loading="loading"
      :headers="headers"
      :items="taxonomy"
      :rows-per-page-text="$t('Rows per page')"
      :pagination.sync="pagination"
      :total-items="total"
      show-select
      select-all
      class="elevation-1"
      item-key="id"
    >
      <v-progress-linear
        slot="progress"
        color="primary"
        indeterminate
      />

      <template v-slot:items="props">
        <tr class="v-datatable__row">
          <td class="text-xs-left">
            <v-checkbox
              v-model="props.selected"
              hide-details
            />
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
        </tr>
      </template>
      <template v-slot:pageText="props">
        <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import ProductService from '@/modules/Products/service'

export default {
  name: 'ProductSingleRelatedTaxonomy',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      total: 0,
      loading: false,
      taxonomy: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Code'), value: 'code' },
        { text: this.$t('Name'), value: 'name' }
      ]
    },
    relatedTaxonomy: {
      get: function () {
        return this.taxonomy.filter(taxon => this.product.related.taxonomy.includes(taxon.id))
      },
      set: function (taxonomy) {
        this.product.related.taxonomy = taxonomy.map(taxon => taxon.id)
      }
    }
  },

  watch: {
    pagination: function () {
      this.getTaxonomy()
    }
  },

  methods: {
    async getTaxonomy () {
      this.loading = true
      const res = await ProductService.loadOnlyTaxonomy(this.pagination)
      this.taxonomy = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
